var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M39.12,20.031c0-4.534,3.675-8.21,8.209-8.21h0.017c4.532,0,8.209,3.676,8.209,8.21v39.277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M12.576,20.031c0-4.534,3.676-8.21,8.209-8.21h0.017c4.533,0,8.209,3.676,8.209,8.21v35.734"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.011,
    y1: 33.166,
    x2: 55.555,
    y2: 33.166
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.011,
    y1: 45.793,
    x2: 55.555,
    y2: 45.793
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M3.605,61.171c7.782,0,7.782,5.758,15.564,5.758c7.78,0,7.78-5.758,15.56-5.758c7.784,0,7.784,5.758,15.566,5.758 c7.784,0,7.784-5.758,15.566-5.758c7.784,0,7.784,5.758,15.569,5.758c7.784,0,7.784-5.758,15.568-5.758"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M97,61.171c-7.784,0-7.784,5.758-15.568,5.758c-7.785,0-7.785-5.758-15.569-5.758c-7.782,0-7.782,5.758-15.566,5.758 c-7.782,0-7.782-5.758-15.566-5.758c-7.779,0-7.779,5.758-15.56,5.758c-7.782,0-7.782-5.758-15.564-5.758"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M3.605,73.179c7.782,0,7.782,5.758,15.564,5.758c7.78,0,7.78-5.758,15.56-5.758c7.784,0,7.784,5.758,15.566,5.758 c7.784,0,7.784-5.758,15.566-5.758c7.784,0,7.784,5.758,15.569,5.758c7.784,0,7.784-5.758,15.568-5.758"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M97,73.179c-7.784,0-7.784,5.758-15.568,5.758c-7.785,0-7.785-5.758-15.569-5.758c-7.782,0-7.782,5.758-15.566,5.758 c-7.782,0-7.782-5.758-15.566-5.758c-7.779,0-7.779,5.758-15.56,5.758c-7.782,0-7.782-5.758-15.564-5.758"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M3.605,85.179c7.782,0,7.782,5.758,15.564,5.758c7.78,0,7.78-5.758,15.56-5.758c7.784,0,7.784,5.758,15.566,5.758 c7.784,0,7.784-5.758,15.566-5.758c7.784,0,7.784,5.758,15.569,5.758c7.784,0,7.784-5.758,15.568-5.758"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M97,85.179c-7.784,0-7.784,5.758-15.568,5.758c-7.785,0-7.785-5.758-15.569-5.758c-7.782,0-7.782,5.758-15.566,5.758 c-7.782,0-7.782-5.758-15.566-5.758c-7.779,0-7.779,5.758-15.56,5.758c-7.782,0-7.782-5.758-15.564-5.758"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.21eb915eae6829bf6f73a18c8b91b522.svg";
export { ForwardRef as ReactComponent };